import PropTypes from "prop-types";
import React from "react";

const TogglePushBtn = ({
  type,
  name,
  icon,
  icontype = "img",
  label,
  btnStyle,
  iconStyle,
  lableStyle,
  value,
  setVal,
  checkedBackColor = "#6f944e",
  initialColor = "#6f944e",
  initialBackColor = "#ecffdb",
  initialBorderColor = "#6f944e",
}) => {
  // console.log(initialBackColor);

  return (
    <button
      className="togglePushBtn"
      style={{
        "--togglePushBtnCheckedColor": checkedBackColor,
        "--togglePushBtnInitialBackColor": initialBackColor,
        "--togglePushBtnInitialBorderColor": initialBorderColor,
        ...btnStyle,
      }}
      type="button"
    >
      {icon ? (
        icontype === "img" ? (
          <img src={icon} alt="" style={iconStyle && iconStyle} />
        ) : (
          icon
        )
      ) : (
        ""
      )}

      <span
        style={{
          "--togglePushBtnInitialColor":
            initialColor !== "" ? initialColor : "#6f944e",
          ...lableStyle,
        }}
      >
        {label && label}
      </span>
      <input
        type={type && type}
        name={name && name}
        checked={
          value &&
          value !== "" &&
          value !== undefined &&
          value.toLowerCase() === label.trim().toLowerCase()
        }
        value={label && label}
        onChange={(e) => setVal(e.target.value)}
      />
    </button>
  );
};

export default TogglePushBtn;

TogglePushBtn.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string,
  icon: PropTypes.element,
  label: PropTypes.string.isRequired,
  btnStyle: PropTypes.object,
  iconStyle: PropTypes.object,
  lableStyle: PropTypes.object,
  icontype: PropTypes.string,
  value: PropTypes.string,
};
